import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { BasicEvaluationTemplateDto, EvaluationTemplateService, TemplateState } from '@proxy/templates';
import { firstValueFrom } from 'rxjs';
import { AppConsts } from '../../AppConsts';

@Component({
    selector: 'app-evaluation-template-dropdown',
    templateUrl: './evaluation-template-dropdown.component.html',
    standalone: false
})
export class EvaluationTemplateDropdownComponent  extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() isReadOnly: boolean;
  @Input() showAreasAssociated = false;
  @Input() userAreaId: string;
  @Input() userSubAreaId: string;
  @Input() filterByRoles = false;
  @Input() operatorAreaIdsForShiftReponsable: string[];
  @Input() operatorSubAreaIdsForShiftReponsable: string[];

  @Output() changeEvaluationTemplate = new EventEmitter<BasicEvaluationTemplateDto>();

  evaluationTemplates: BasicEvaluationTemplateDto[] = [];
  evaluationTemplateSelected: BasicEvaluationTemplateDto;

  constructor(
    injector: Injector,
    private readonly _evaluationService: EvaluationTemplateService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadBasicEvaluationTemplates();
    this.onSelected();
  }

  onSelected(): void {
    this.changeEvaluationTemplate.emit(this.evaluationTemplateSelected);
  }

  private async loadBasicEvaluationTemplates(): Promise<void> {
    try {
      this.showLoading();

      this.evaluationTemplates = await firstValueFrom(this._evaluationService.getAllBasicTemplatesByInput({
        skipCount: undefined,
        maxResultCount: AppConsts.MaxPageSize,
        areaIds: this.getAreaIsToFilter(),
        subAreaIds: this.getSubAreaIsToFilter(),
        state: TemplateState.Active,
        filterByRoles: this.filterByRoles
      }));

      if (this.evaluationTemplates.length === 1) {
        this.evaluationTemplateSelected = this.evaluationTemplates[0];
        this.onSelected();
      }
      
    } finally {
      this.hideLoading();
    }
  }

  private getAreaIsToFilter(): string[] {
    return this.isDefinedAndStrictlyPositiveNumber(this.operatorAreaIdsForShiftReponsable?.length) ? this.operatorAreaIdsForShiftReponsable : [this.userAreaId];
  }

  private getSubAreaIsToFilter(): string[] {
    return this.isDefinedAndStrictlyPositiveNumber(this.operatorSubAreaIdsForShiftReponsable?.length) ? this.operatorSubAreaIdsForShiftReponsable : [this.userSubAreaId];
  }
}
